import { RootState } from "store"; // Adjust the import path as needed
import { AnalyticsState } from "./analyticsSlice";

const analyticsState = (state: RootState) => state.analytics as AnalyticsState;
export const selectAnalytics = (state: RootState): AnalyticsState => analyticsState(state);

export const selectDistributorSales = (state: RootState) => analyticsState(state).distributorSales;
export const selectDistributorOrgTestCounts = (state: RootState) =>
  analyticsState(state).distributorOrgTestCounts;
export const selectCategoryDistribution = (state: RootState) =>
  analyticsState(state).distributorCategoryDistribution;
export const selectDemoTestTotals = (state: RootState) => analyticsState(state).demoTestTotals;
export const selectDistributorComparison = (state: RootState) =>
  analyticsState(state).distributorComparison;
export const selectMultiAccountDevices = (state: RootState) =>
  analyticsState(state).multiAccountDevices;
export const selectOrgBreakdowns = (state: RootState) => analyticsState(state).orgBreakdowns;
export const selectOrgTestCounts = (state: RootState) => analyticsState(state).orgTestCounts;
export const selectSingleDeviceTestCounts = (state: RootState) =>
  analyticsState(state).singleDeviceTestCounts;
export const selectAllDistributorIds = (state: RootState) =>
  analyticsState(state).allDistributorIds;
